var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.333,
    d: "M25 3.332H10a3.333 3.333 0 0 0-3.334 3.333v26.667a3.334 3.334 0 0 0 3.333 3.333h20a3.334 3.334 0 0 0 3.334-3.333V11.665z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.333,
    d: "M23.334 3.332v6.667a3.333 3.333 0 0 0 3.333 3.333h6.667M16.667 15h-3.333M26.667 21.668H13.334M26.667 28.332H13.334"
  })));
};
export default SvgFile;